import React from 'react';

import './Footer.css';

const Footer = () => (
    <div className='footer'>
        <p> © 2020 Smart Stay </p>
        <p>Made with Love by Prabh</p>
    </div>

);

export default Footer;
